export default "__VITE_ASSET__c8bc9303__"